module.exports = __webpack_public_path__ + "img/discord-text-color.a881bbc7.svg";